<template>
    <div class="row py-lg-5">
        <div class="col-12 no-inner-padding">
            <div v-if="useSlider" class="tiny-slider">
                <EducationCard
                    v-for="education in educations"
                    :key="education.id"
                    :education="education"
                ></EducationCard>
            </div>
            <div v-else class="row">
                <EducationCard
                    v-for="education in educations"
                    :key="education.id"
                    class="col-12 col-md-6 col-lg-4"
                    :education="education"
                ></EducationCard>
            </div>
        </div>
    </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import EducationCard from '@/components/education/education-card';

export default {
    components: {
        EducationCard
    },

    props: {
        educations: {
            type: Array,
            default() {
                return [];
            }
        },
        useSlider: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            slider: null
        };
    },

    mounted() {
        if (this.useSlider) {
            this.$nextTick(() => {
                this.initSlider();
            });
        }
    },

    methods: {
        initSlider() {
            this.slider = tns({
                container: this.$el.querySelector('.tiny-slider'),
                items: 1,
                gutter: 20,
                slideBy: 1,
                mouseDrag: true,
                swipeAngle: false,
                controls: false,
                lazyload: false,
                nav: true,
                navPosition: 'bottom',
                preventScrollOnTouch: 'auto',
                speed: 400,
                responsive: {
                    992: {
                        items: 3,
                        mouseDrag: false,
                        slideBy: 3
                    }
                }
            });
        }
    }
};
</script>
